import React, { useState, useEffect } from "react";
import { 
  Card, 
  Grid, 
  CardMedia, 
  CardContent, 
  Typography, 
  Box, 
  Button,
  Chip
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';

const BatchNftCard = ({ nft, index, onViewNft }) => {
  const [claimedAt, setClaimedAt] = useState("");

  useEffect(() => {
    if (nft.claimedAt) {
      const formattedClaimedDate = new Date(nft.claimedAt);
      const formattedString =
        formattedClaimedDate.toDateString() +
        " " +
        formattedClaimedDate.getHours().toString().padStart(2, "0") +
        ":" +
        formattedClaimedDate.getMinutes().toString().padStart(2, "0");

      setClaimedAt(formattedString);
    }
  }, [nft.claimedAt]);

  const handleDownload = async () => {
    try {
      // Use the same download logic as the individual NFT view
      const encodedImageUrl = encodeURIComponent(nft.imageUrl);
      const downloadUrl = `/api/nft/download-image/?imageUrl=${encodedImageUrl}`;
      
      // Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `${nft.title}-Series${nft.series}-Edition${nft.individual}.jpeg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading NFT:', error);
    }
  };

  return (
    <Card sx={{ display: "flex", marginBottom: 2, position: 'relative' }}>
      {/* NFT Index Badge */}
      <Chip 
        label={`#${index}`} 
        color="primary" 
        size="small"
        sx={{ 
          position: 'absolute', 
          top: 8, 
          left: 8, 
          zIndex: 1,
          fontWeight: 'bold'
        }} 
      />
      
      <Grid container>
        <Grid item xs={12} sm={4}>
          <CardMedia
            component="img"
            sx={{ 
              width: "100%", 
              height: { xs: 250, sm: "100%" },
              minHeight: { sm: 200 }
            }}
            image={nft.imageUrl}
            alt={nft.title}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <CardContent sx={{ pt: 3 }}>
            <Typography variant="h5" gutterBottom>
              {nft.title}
            </Typography>

            {nft.verified && (
              <Box sx={{ display: "flex", alignItems: "center", color: "green", mb: 2 }}>
                <CheckCircleIcon sx={{ mr: 1 }} />
                <Typography variant="body1">Verified Purchase</Typography>
              </Box>
            )}

            <Box sx={{ mb: 2 }}>
              <Typography variant="body1">
                <strong>Series:</strong> {nft.series}
              </Typography>
              <Typography variant="body1">
                <strong>Edition:</strong> {nft.individual}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>NFT ID:</strong> {nft._id}
              </Typography>
            </Box>

            <Typography variant="body2" sx={{ mb: 2 }}>
              {nft.description}
            </Typography>

            {claimedAt && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                <strong>Claimed:</strong> {claimedAt}
              </Typography>
            )}

            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<VisibilityIcon />}
                onClick={() => onViewNft(nft)}
                size="small"
              >
                View Details
              </Button>
              
              <Button
                variant="outlined"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
                size="small"
              >
                Download
              </Button>
            </Box>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  );
};

export default BatchNftCard; 